<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <text-input v-model="form.date" :error="form.errors.date" type="date" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Date')" readonly />

        <div class="pr-6 pb-8 w-full">
          <label class="form-label">{{ __('Details') }}:</label>
          <div v-for="(detail, index) in form.details" :key="index" class="flex items-center space-x-4 mb-4">
            <select-input v-model="detail.asset_id" :error="form.errors[`details.${index}.asset_id`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Asset')" :required="true" :disabled="true">
              <option :value="null">{{ __('Select asset') }}</option>
              <option v-for="s in asset" :key="s.id" :value="s.id">{{ s.name }}</option>
            </select-input>
            <text-input v-model="detail.code" :error="form.errors[`details.${index}.code`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Code Asset')" readonly />
            <text-input v-model="detail.brand" :error="form.errors[`details.${index}.brand`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Brand')" readonly />
            <text-input v-model="detail.type" :error="form.errors[`details.${index}.type`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Type')" readonly />
            <text-input v-model="detail.serial_number" :error="form.errors[`details.${index}.serial_number`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Serial Number')" readonly />
            <text-input v-model="detail.qty" :error="form.errors[`details.${index}.qty`]" type="number" min="1" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Qty')" readonly />
          </div>
        </div>
      </div>
      <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
        <Link class="text-indigo-600 hover:text-indigo-900" :href="this.route('incoming_goods')" tabindex="-1"> Back </Link>
      </div>
    </div>
  </div>
</template>


<script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { formatDate } from '@/utils/dateFormatter.js'

export default {
  metaInfo() {
    return { title: this.title }
  },
  components: {
    LoadingButton,
    TextInput,
    SelectInput,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    data_incoming_goods: Object,
    asset: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        date: formatDate(this.data_incoming_goods.date, 'YYYY-MM-DD'),
        details: this.data_incoming_goods.details.map((detail) => ({
          asset_id: detail.asset_id,
          code: detail.code,
          brand: detail.brand,
          type: detail.type,
          serial_number: detail.serial_number,
          qty: detail.qty,
        })),
      }),
    }
  },
  methods: {
    removeDetail(index) {
      // Method to remove the detail; implement if necessary
    },
    addDetail() {
      // Method to add a new detail; implement if necessary
    },
  },
}
</script>
